export const chartEditActions = {
	addWidget: "addWidget",
	removeWidget: "removeWidget",
	reorderWidgets: "reorderWidgets",
	addPlayer: "addPlayer",
	removePlayer: "removePlayer",
};
